import Axios from 'axios'
import {departmentUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_departments (context) {
    Axios.get(departmentUrls.getAllDepartments).then(function (response) {
      context.commit('GET_ALL_DEPARTMENTS', response.data)
    })
  },
  get_departments (context, publicId) {
    Axios.get(departmentUrls.getDepartments + publicId).then(function (response) {
      context.commit('GET_DEPARTMENTS', response.data)
    })
  },
  get_deleted_departments (context) {
    Axios.get(departmentUrls.getDeletedDepartment).then(function (response) {
      context.commit('GET_DELETED_DEPARTMENTS', response.data)
    })
  },
  get_department (context, publicId) {
    Axios.get(departmentUrls.getDepartment + publicId).then(function (response) {
      context.commit('GET_DEPARTMENT', response.data)
    })
  },
  post_department (context, data) {
    Axios.post(departmentUrls.postDepartment, data).then(function () {
      context.dispatch('get_all_departments')
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_department (context, data) {
    Axios.post(departmentUrls.editDepartment + data.public_id, data).then(function () {
      context.dispatch('get_all_departments')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_department (context, data) {
    Axios.post(departmentUrls.deleteDepartment + data.public_id, data).then(function () {
      context.dispatch('get_all_departments')
    })
  },
  restoreDepartment (context, publicId) {
    Axios.get(departmentUrls.restoreDepartment + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_DEPARTMENTS', response.data)
      router.push({
        name: 'Module.Departments'
      })
    })
  }
}
